import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getProductDetails } from "../service/productdetails.service";

export const fetchProductDetails = createAsyncThunk(
  "productDetails/fetchProductDetails",
  async (slug, { rejectWithValue }) => {
    try {
      return await getProductDetails(slug);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const initialState = {
  products: [],
  loading: false,
  error: null,
};

const productDetailsSlice = createSlice({
  name: "productDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload || [];
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.loading = false;
        state.products = [];
        state.error = action.payload;
      });
  },
});
export default productDetailsSlice.reducer;